<template>
  <div id="Delete" class="slideUp">
    <i id="close" class="anyteachicon anyteach-guanbi" @click="end()" />
    <div v-if="!isDeleted" class="content">
      <div class="text">
        <h1>确认取消课程？</h1>
        <h2>已加入的参与人将收到自动退款，课程将关闭。</h2>
      </div>
      <div class="button" @click="deleteClass()">取消课程</div>
    </div>
    <div v-else class="content animated fadeIn">
      <div class="text">
        <i class="anyteachicon anyteach-check-circle red animated bounce" />
        <h1>课程已取消</h1>
        <h2>
          您可以再次
          <router-link to="/homeclass/post" tag="span">发起课程</router-link>，或
          <router-link tag="span" to="/homeclass">查看其他课程</router-link>。
        </h2>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Delete",
  data() {
    return {
      isDeleted: false,
    }
  },
  methods: {
    deleteClass() {
      this.$axios({
        url: window.PHP_ROOT + "/index/collage/delete",
        data: { id: this.$route.params.id },
        method: "POST",
      }).then(({ data }) => {
        const { code } = data
        if (code == 1000) {
          this.isDeleted = true
          this.$emit("deleted")
        } else {
          this.$toast("取消失败，请稍后重试")
        }
      }).catch(error => {
        this.$toastError("网络失败，请稍后重试")

      })
    },
    end() {
      document.getElementById("Delete").classList.remove("slideUp")
      document.getElementById("Delete").classList.add("slideDown")
      setTimeout(() => {
        this.$emit("close")
      }, 300)
    },
  },
}
</script>
<style scoped lang="scss">
// @import "../../../../static/css/public.scss";

#Delete {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: white;
  z-index: 997;
  display: block;
  margin: 0;
  .content {
    margin: auto;
    width: 90%;
    color: $black;
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-content: space-between;
    height: calc(100% - 81px);
    padding: 15% 0 30px 0;
    animation-duration: 0.3s !important;
    i {
      font-size: 40px;
      margin-bottom: 20px;
    }
    h1 {
      font-size: 25px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    h2 {
      font-size: 15px;
      font-weight: 300;
      line-height: 1.5;
      padding: 0 5%;
      span {
        color: $red;
        font-weight: 400;
      }
    }

    .button {
      color: white;
      font-weight: 500;
      font-size: 15px;
      background: $black;
      border-radius: 3px;
      width: 100%;
      padding: 8px;
      &:active {
        opacity: 0.7;
      }
    }
  }
}
</style>
